import { render } from "./MainTopBar.vue?vue&type=template&id=7c51f548&scoped=true"
import script from "./MainTopBar.vue?vue&type=script&lang=js"
export * from "./MainTopBar.vue?vue&type=script&lang=js"

import "./MainTopBar.vue?vue&type=style&index=0&id=7c51f548&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c51f548"]])

export default __exports__